import { cn } from '@utils/helpers';
import type * as React from 'react';
import { Link, animateScroll } from 'react-scroll';
import { sectionNavigationClassName } from './lib/SectionNavigationStyles';
import type { SectionNavigationPropsType } from './types';

const SectionNavigation: React.FC<SectionNavigationPropsType> = (props: SectionNavigationPropsType) => (
  <nav className={cn('Base-inlineNav-wrapper', sectionNavigationClassName)}>
    <ul>
      {props.sectionNavigation.map((item, index) => (
        <li key={item.anchorName} className="my-0 pb-2 last:pb-0">
          {index === 0 ? (
            <a
              href={`#${item.anchorName}`}
              onClick={(e) => {
                e.preventDefault();
                animateScroll.scrollToTop({
                  duration: (scrollDistanceinPx) => Math.min(Math.abs(scrollDistanceinPx) / 2, 1500),
                });
              }}
              className={cn('flex items-center justify-start hover:text-accent font-body text-xs', {
                'text-accent': props.activeIndex === index,
                'text-black': props.activeIndex !== index,
              })}
            >
              {item.navigationTitle}
            </a>
          ) : (
            <Link
              to={item.anchorName}
              duration={(scrollDistanceinPx) => Math.min(Math.abs(scrollDistanceinPx) / 2, 1500)}
              offset={0}
              smooth={true}
              className={cn('flex items-center justify-start hover:text-accent font-body text-xs', {
                'text-accent': props.activeIndex === index,
                'text-black': props.activeIndex !== index,
              })}
            >
              {item.navigationTitle}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </nav>
);

export { SectionNavigation };
